/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable-next-line jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import queryString from 'querystring';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

type Params = {
  id: number;
};

export function AdminBannerMod(routeProps: RouteComponentProps) {
  const history = useHistory();
  const { match, location } = routeProps;
  const { id } = match.params as Params;

  const [savedFile, setSavedFile] = useState<File>();
  const [savedFileName, setSavedFileName] = useState<string>('');
  const [savingFile, setSavingFile] = useState<File>();
  const [siteUrlText, setSiteUrlText] = useState('http://www.');
  const [collegeText, setCollegeText] = useState('');
  const [targetText, setTargetText] = useState('_blank');
  const [fileUrl, setFileUrl] = useState('');
  const [bannerFlag, setBannerFlag] = useState<Number>();
  const dispatch = useDispatch();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    if (+id > 0) {
      server.getBanner(id).then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setBannerFlag(Number(payload.flag));
          setTargetText(payload.target);
          setCollegeText(payload.college);
          setSiteUrlText(payload.siteUrl);
          setSavedFile(payload.imageUrl);
          setSavedFileName(payload.image);
        }
      });
    }
  }, []);

  // 수정 버튼 클릭 시
  const updateBanner = async () => {
    const savedBanner = await server
      .updateBanner(Number(id), {
        siteUrl: siteUrlText,
        college: collegeText,
        target: targetText,
        flag: String(bannerFlag),
      })
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          dispatch(toast.info({ message: '정상적으로 저장되었습니다.' }));
        }
        history.push('/admin/banner-logo/banner');
        return payload;
      });

    if (savedBanner !== undefined) {
      const savedBannerId = savedBanner.id;
      if (savingFile !== undefined) {
        await server
          .updateBannerAttache(savedBannerId, { image: savingFile })
          .then(() => {
            history.push('/admin/banner-logo/banner');
          })
          .catch((error) => {
            dispatch(toast.error({ message: '첨부파일 에러' }));
            return error;
          });
      }
    }
  };

  // 배너이미지 업로드
  const attachFileDom = () => {
    return (
      <li>
        <span className="">현재 배너 이미지</span>
        <small className="file-return" />
        <img
          src={savedFile ? `${process.env.REACT_APP_API_URL}/public${savedFile}` : ''}
          alt={savedFileName}
        />
        {/* {savedFile ? `${process.env.REACT_APP_API_URL}/public${savedFile}` : ''} */}
        <small>※ 사이즈: 125x40 (픽셀)</small>
      </li>
    );
  };

  // 테이블 양식
  function createBannerTable() {
    return (
      <main className="images wrapper">
        <ul className="inputs">
          {attachFileDom()}
          <li>
            <span className="required">등록할 배너 이미지</span>
            <div className="input-file-container">
              <input
                className="input-file"
                id="file02"
                type="file"
                onChange={(e) => {
                  if (
                    e.target !== null &&
                    e.target.files !== null &&
                    e.target.files[0] !== undefined
                  ) {
                    setSavingFile(e.target.files[0]);
                    const preview = e.target.files[0];
                    const imageUrl = URL.createObjectURL(preview);
                    setFileUrl(imageUrl);
                  }
                }}
              />
              <label tabIndex={0} htmlFor="file02" className="input-file-trigger">
                파일 선택
              </label>
            </div>
            <img
              src={fileUrl}
              alt=""
              onLoad={() => {
                dispatch(toast.info({ message: '이미지 업로드 완료.' }));
                window.URL.revokeObjectURL(fileUrl);
              }}
            />
            <small>※ 사이즈: 125x40 (픽셀)</small>
          </li>
          <li>
            <span>연결 URL</span>
            <input
              id="siteUrl"
              className="full"
              type="url"
              value={siteUrlText || ''}
              onChange={(e) => {
                setSiteUrlText(e.target.value);
              }}
            />
          </li>
          <li>
            <span>상호명</span>
            <input
              id="college"
              type="text"
              value={collegeText || ''}
              onChange={(e) => {
                setCollegeText(e.target.value);
              }}
            />
            <small>※ 해당 배너의 업체명을 입력해주세요.</small>
          </li>
          <li>
            <span className="required">구분</span>
            <div className="radio">
              <input
                type="radio"
                checked={Number(bannerFlag) === 1}
                id="cooperative"
                name="flag"
                value="cooperative"
                onClick={() => setBannerFlag(1)}
              />
              <label
                htmlFor="cooperative"
                onClick={() => setBannerFlag(1)}
                style={{ display: 'flex' }}
              >
                협력사
              </label>
            </div>
            <div className="radio">
              <input
                type="radio"
                checked={Number(bannerFlag) === 2}
                id="academy"
                name="flag"
                value="academy"
                onClick={() => setBannerFlag(2)}
              />
              <label htmlFor="academy" onClick={() => setBannerFlag(2)} style={{ display: 'flex' }}>
                교육기관
              </label>
            </div>
          </li>
        </ul>
      </main>
    );
  }

  // AdminBannerAdd 리턴값
  return (
    <main className="images wrapper">
      <div className="title">
        <h1>협력사 / 교육기관 배너 수정하기</h1>
        <div className="buttons">
          <button type="button" onClick={updateBanner}>
            수정
          </button>
        </div>
      </div>
      <div className="content">{createBannerTable()}</div>
    </main>
  );
}
